export default "__VITE_ASSET__BYcSr5qJ__"